export enum MuseContentSuggestContentType {
  AdCopy = 'AdCopy',
  EmailPreheader = 'EmailPreheader',
  EmailSubjectLine = 'EmailSubjectLine',
  PushBody = 'PushBody',
  PushTitle = 'PushTitle',
  SmsMessage = 'SmsMessage',
  WhatsAppMessage = 'WhatsAppMessage',
}
